export default {
  unreadCount: 0,
  notification_limit: 1,
  unreadMessages: 0, //顾问在线未读消息数
  quantity: 0, //公告未读消息数
  waitNum: 0, //协同门诊待接诊数量
}
